// src/components/reports/CompanyTrendReport/TrendTabs.tsx

import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

interface TrendTabsProps {
  viewMode: 'chart' | 'table';
  onViewModeChange: (newValue: 'chart' | 'table') => void;
}

export const TrendTabs: React.FC<TrendTabsProps> = ({
  viewMode,
  onViewModeChange
}) => {
  // 表示モード切り替えのハンドラー
  const handleViewModeChange = (event: React.SyntheticEvent, newValue: 'chart' | 'table') => {
    onViewModeChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs value={viewMode} onChange={handleViewModeChange} aria-label="表示モード">
        <Tab label="グラフ表示" value="chart" />
        <Tab label="表形式" value="table" />
      </Tabs>
    </Box>
  );
};